import React, { useEffect } from 'react';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Services from '../components/Services';

const Home = () => {
    useEffect(() => {
        // Get the hash from the URL
        const hash = window.location.hash;
        if (hash) {
            // Wait for the page to load
            setTimeout(() => {
                const element = document.querySelector(hash);
                if (element) {
                    const yOffset = -80; // Adjust this value based on your navbar height
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }, 500); // Delay of 500ms to ensure content is loaded
        }
    }, []);

    return (
        <>
            <Hero />
            <Intro />
            <Services />
            <Cta/>
            <Footer />
        </>
    )
}

export default Home;
